export default "Calculez la trajectoire OPERAT de votre patrimoine bâti tertiaire (mairie, salle polyvalente, école…) et obtenez votre plan d'actions 2030. Compatible Fonds vert.";
